import { atom } from "recoil";

// current tenant

const tenantState = atom({
    key: "tenant",
    default: undefined
});

export default tenantState;